import { config } from '@uhg-abyss/web/tools/config';
import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { validationTermsError, updateTermsOfUseError } from './errors';

export const updateTermsOfUse = async (payload) => {
  const { action } = payload;
  const response = await http({
    id: 'epv-updateTermsOfUse',
    method: 'PUT',
    cache: false,
    withCredentials: true,
    url: `${config('TERMS_OF_USER_ACCEPTED_CHECK_URL')}/api/terms/accept`,
    handleError: updateTermsOfUseError,
    body: action.payload,
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};

export const validateTermsOfUse = async (payload) => {
  const { action } = payload;
  const { uuid } = action.payload;

  const response = await http({
    id: 'epv-updateTermsOfUse',
    method: 'GET',
    cache: false,
    withCredentials: true,
    url: `${config('TERMS_OF_USER_ACCEPTED_CHECK_URL')}/api/terms`,
    handleError: validationTermsError,
    query: {
      uuid,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  const { accepted } = data;
  const boolVal = /true/i.test(accepted);
  return { accepted: boolVal };
};
